import AboutPageSection from "./AboutPageSection";
import Banner from "./Banner";
import LegacySection from "./LegacySection";
import Mission from "./Mission";
import OurStory from "./Ourstory";

const AboutUs = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <AboutPageSection language={language} />
      <Mission language={language} />
      <OurStory language={language} />
      <LegacySection language={language} />
    </>
  );
};

export default AboutUs;